import { useState, useEffect } from 'react';

export function useTheme() {
  const getInitial = () => {
    const saved = localStorage.getItem('paydirt-theme');
    if (saved) return saved;
    return 'dark';
  };

  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('paydirt-theme', theme);
  }, [theme]);

  const toggle = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return { theme, toggle };
}
